var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import debounce from 'lodash.debounce';
import { useCallback, useMemo, useRef, useState } from 'react';
import { FactoryComponent } from '../../../factory';
import useDesign from '../../../hooks/useDesign';
import { Portal } from '../../atoms/Portal';
import { TooltipPopover } from './components/TooltipPopover';
import { BackgroundOverlay, Wrapper } from './styled';
var TRIGGER_EVENTS = {
    click: 'click',
    hover: 'hover',
};
export var Tooltip = function (_a) {
    var _b;
    var _c = _a.design, design = _c === void 0 ? '' : _c, error = _a.error, props = __rest(_a, ["design", "error"]);
    var _d = useDesign(design), schema = _d.schema, components = _d.components, config = _d.config;
    var _e = (props === null || props === void 0 ? void 0 : props.config) || {}, activatorConf = _e.activator, popoverConf = _e.popover;
    var triggerEvent = config.event || props.event || TRIGGER_EVENTS.hover;
    var alwaysOn = config.alwaysOn || props.alwaysOn;
    var position = (popoverConf === null || popoverConf === void 0 ? void 0 : popoverConf.position) || config.position || props.position;
    var _f = useState(!!(config.on || props.on)), isOn = _f[0], setOn = _f[1];
    var visible = isOn || alwaysOn;
    var activatorRef = useRef(null);
    var debounceRef = useRef(null);
    var handleMouseEnter = useCallback(function () {
        var _a;
        (_a = debounceRef.current) === null || _a === void 0 ? void 0 : _a.cancel();
        setOn(true);
    }, []);
    var handleMouseLeave = useCallback(function () {
        debounceRef.current = debounce(function () {
            setOn(false);
        }, 300);
        debounceRef.current();
    }, []);
    var handleClick = useCallback(function () {
        setOn(true);
    }, []);
    var hoverActivatorProps = useMemo(function () { return ({
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
    }); }, [handleMouseEnter, handleMouseLeave]);
    var clickActivatorProps = useMemo(function () { return ({
        onClick: handleClick,
    }); }, [handleClick]);
    var activatorOptions = (_b = {},
        _b[TRIGGER_EVENTS.click] = clickActivatorProps,
        _b[TRIGGER_EVENTS.hover] = hoverActivatorProps,
        _b);
    var activatorProps = __assign({}, activatorOptions[triggerEvent]);
    return (_jsxs(Wrapper, __assign({ schema: schema }, { children: [isOn && !alwaysOn && triggerEvent === TRIGGER_EVENTS.click && (_jsx(BackgroundOverlay, { onClick: function () { return setOn(false); } })), _jsx(FactoryComponent, __assign({ ref: activatorRef, design: components.activator, error: error, config: activatorConf }, (!alwaysOn ? activatorProps : {}))), visible && (_jsx(Portal, { children: _jsx(TooltipPopover, __assign({ el: activatorRef.current, design: components.popover, position: position, values: props.values, config: __assign(__assign({}, popoverConf), props === null || props === void 0 ? void 0 : props.popover) }, (triggerEvent === TRIGGER_EVENTS.hover && !alwaysOn ? hoverActivatorProps : {}))) }))] })));
};
Tooltip.displayName = 'Tooltip';
